import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="border-t border-ink-900/10 bg-paper"
      data-testid="site-footer"
    >
      <div className="wrap py-14">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="eyebrow">Independent consultant</p>
            <h3 className="display mt-4 text-3xl font-medium leading-[1.05] sm:text-4xl">
              Let's design the
              <br />
              <em className="font-normal italic text-clay-600">payments stack</em>{" "}
              your product actually needs.
            </h3>
            <Link
              to="/contact"
              className="btn-primary mt-7"
              data-testid="footer-cta-contact"
            >
              Get in touch →
            </Link>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow mb-4">Contact</p>
            <ul className="space-y-2 text-[14.5px] text-ink-800">
              <li data-testid="footer-name">
                <span className="text-ink-400">Name · </span>
                <span className="font-medium">Roman Ryzhov</span>
              </li>
              <li data-testid="footer-business">
                <span className="text-ink-400">Studio · </span>
                <span className="font-medium">VRH Digital</span>
              </li>
              <li data-testid="footer-email">
                <span className="text-ink-400">Email · </span>
                <a
                  href="mailto:rryzhov@gmail.com"
                  className="link-underline font-medium"
                >
                  rryzhov@gmail.com
                </a>
              </li>
              <li data-testid="footer-location">
                <span className="text-ink-400">Based in · </span>
                <span className="font-medium">Kharkiv, Ukraine</span>
              </li>
              <li data-testid="footer-website">
                <span className="text-ink-400">Web · </span>
                <a
                  href="https://vrhdigital.com"
                  className="link-underline font-medium"
                >
                  vrhdigital.com
                </a>
              </li>
              <li data-testid="footer-langs">
                <span className="text-ink-400">Languages · </span>
                <span className="font-medium">UA · RU · EN</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow mb-4">Capabilities</p>
            <ul className="space-y-2 text-[14.5px] text-ink-800">
              <li>Payment Processing & FinTech</li>
              <li>Payment Orchestration & Routing</li>
              <li>Subscription / Rebill Operations</li>
              <li>QA, UAT & Incident Investigation</li>
              <li>E-commerce & API Integrations</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-ink-900/10 pt-6 text-[12.5px] text-ink-500 md:flex-row md:items-center">
          <p className="font-mono uppercase tracking-[0.18em]">
            © {new Date().getFullYear()} VRH Digital — Roman Ryzhov · vrhdigital.com
          </p>
          <p className="font-mono uppercase tracking-[0.18em]">
            Kharkiv, UA · Available worldwide
          </p>
        </div>
      </div>
    </footer>
  );
}
